import React from 'react'

import { useStyles } from './ProgressBar.styles'
import SVG from '../../SVG/SVG'
import Gtm from '../../../../utils/gtm'
import { loggingEnabled } from '../../../../utils/logging'

export const ProgressBar = ({ changeTabs, activeTab, tabStatus, isPanelForm }) => {
  const classes = useStyles(isPanelForm)()
  const gtm = new Gtm(loggingEnabled)

  return (
    <div className={classes.progressBar}>
      <div className={classes.bar}></div>
      <div
        onClick={() => {
          if (activeTab > 0) changeTabs(false, 0)
        }}
        className={`${classes.tabSelector} ${activeTab === 0 ? 'current-tab' : ''} ${tabStatus[0] ??
          ''}`}
      >
        <SVG name={'Details'} width={64} height={63} />
        <p>Your details</p>
      </div>

      <div
        onClick={() => {
          if (activeTab > 1) changeTabs(false, 1)
        }}
        className={`${classes.tabSelector} ${activeTab === 1 ? 'current-tab' : ''} ${tabStatus[1] ??
          ''}`}
      >
        <SVG name={'Address'} width={64} height={63} />
        <p>Address</p>
      </div>

      <div
        onClick={() => {
          if (activeTab > 2) changeTabs(false, 2)
        }}
        className={`${classes.tabSelector} ${activeTab === 2 ? 'current-tab' : ''} ${tabStatus[2] ??
          ''}`}
      >
        <SVG name={'Rental'} width={64} height={63} />
        <p>Driver`s license</p>
      </div>
    </div>
  )
}

export default ProgressBar
